import { Shield, Star, Award, Zap, Crown, Sword, Flame, Gem, Skull, Heart, Medal, Rocket, Ghost, Diamond, Sparkles, Trophy, Target, Eye, Bug, Bot } from "lucide-react";

export const ROLE_ICONS = {
  crown: Crown, shield: Shield, star: Star, award: Award, zap: Zap, sword: Sword, flame: Flame, gem: Gem, skull: Skull,
  heart: Heart, medal: Medal, rocket: Rocket, ghost: Ghost, diamond: Diamond, sparkles: Sparkles, trophy: Trophy, target: Target, eye: Eye, bug: Bug, bot: Bot,
};

export const ROLE_COLORS = ["#00F0FF", "#3B82F6", "#34d399", "#fbbf24", "#f59e0b", "#c084fc", "#f472b6", "#ef4444", "#fb923c", "#a3e635", "#e2e8f0", "#facc15"];

export const ADMIN_ROLE = { id: "admin", label: "ADMIN", color: "#f87171", icon: "crown" };

export function roleFor(user, rolesMap = {}) {
  if (!user) return null;
  if (user.role === "admin") return ADMIN_ROLE;
  if (user.mod_role && rolesMap[user.mod_role]) return rolesMap[user.mod_role];
  return null;
}

export function nameColor(user, rolesMap = {}) {
  const r = roleFor(user, rolesMap);
  return r ? r.color : "#a5f3fc";
}
